module.exports = __webpack_public_path__ + "static/media/microphone-alt.cdc81d86.svg";